var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2631 36.5508C21.7295 38.0813 13.7762 38.8474 5.68665 36.5508C2.53595 35.6566 0 33.6675 0 30.8127C0 27.9319 2.62572 26.1159 5.7668 25.0653C12.2518 22.8951 19.4765 22.6334 27.1829 25.0653C30.3433 26.0622 32.9497 27.9319 32.9497 30.8127C32.9497 33.6675 30.4218 35.6772 27.2631 36.5508Z",
    fill: "#C3C3C3",
    fillOpacity: 0.58
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4748 20.8681C22.317 20.8681 27.053 16.1966 27.053 10.434C27.053 4.67147 22.317 0 16.4748 0C10.6326 0 5.89661 4.67147 5.89661 10.434C5.89661 16.1966 10.6326 20.8681 16.4748 20.8681Z",
    fill: "#C3C3C3",
    fillOpacity: 0.58
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9497 12.688C30.1604 12.688 27.8994 14.9182 27.8994 17.6694C27.8994 20.4206 30.1604 22.6508 32.9497 22.6508C35.7389 22.6508 37.9999 20.4206 37.9999 17.6694C37.9999 14.9182 35.7389 12.688 32.9497 12.688ZM32.9497 14.564C33.2575 14.564 33.5548 14.6099 33.8361 14.6913L29.9304 18.5438C29.8479 18.2663 29.8014 17.973 29.8014 17.6694C29.8014 15.9547 31.2104 14.5648 32.9489 14.5648L32.9497 14.564ZM32.9497 20.774C32.6419 20.774 32.3445 20.7281 32.0632 20.6467L35.9689 16.7942C36.0515 17.0717 36.098 17.365 36.098 17.6686C36.098 19.3834 34.6889 20.7732 32.9505 20.7732L32.9497 20.774Z",
    fill: "#C3C3C3",
    fillOpacity: 0.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivo);
export default __webpack_public_path__ + "static/media/inactivo.a9ecb00521bc338ec8aed5b0e038c4d8.svg";
export { ForwardRef as ReactComponent };